export function getCreditorInitials(creditorName: string): string {
  const words = creditorName.trim().split(/\s+/);
  if (words.length === 0) return '';
  if (words.length === 1) return words[0].substring(0, 2).toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
}

/**
 * The debt to brand a multi-debt surface with, or null when the debts span clients.
 * Keyed on client id: two clients can share a display name, and a debt whose client
 * is unknown cannot vouch for the others.
 */
export function soleCreditor<T extends { clientId: string | null }>(debts: T[]): T | null {
  const [first] = debts;
  if (!first?.clientId) return null;
  return debts.every((d) => d.clientId === first.clientId) ? first : null;
}
